module.exports = __webpack_public_path__ + "static/media/S_S01.6a75c019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/S_S01.png
// module id = 83
// module chunks = 0